import Util from '@/helper/Utility.js';
export default function MyorderConfigModel(date, intTop, intSkip) {
    this.isSeeMoreEnable = true;
    this.date = date || null;
    this.intSkip = intSkip || 0;
    this.defaultTopAmount = intTop || 25;

    this.resetListConfig = function () {
        this.isSeeMoreEnable = true;
        this.intSkip = 0;
    };

    this.getParams = function() {
        var params = {
            date: this.date,
            top: this.defaultTopAmount,
            skip: this.intSkip,
        };
        params = Util.cleanObjectEmptyStr(params);
        return params;
    };
}